import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The Angular Material default paginator is shit without knowing max length.
 * Here we have a new paginator that doesn't care about max length.
 * Have these guys never heard of server-size pagination?
 */
@Component({
    selector: 'app-paginator',
    template: `
    <div class="paginator">
      <div class="paginator-page">
        <div class="paginator-text">Page {{pageIndex+1}}</div>
        <div class="paginator-size" *ngIf="pageSize">
          <div class="paginator-text">Size</div>
          <div *ngIf="!pageSizeOptions.length">{{pageSize}}</div>
          <mat-select *ngIf="pageSizeOptions.length" class="paginator-select" [hideSingleSelectionIndicator]="true" [value]="pageSize" (valueChange)="paginate(pageIndex, $event)">
            <mat-option class="paginator-option" *ngFor="let p of pageSizeOptions" [value]="p">{{p}}</mat-option>
          </mat-select>
        </div>
      </div>
      <button mat-icon-button (click)="paginate(0, pageSize)" [disabled]="pageIndex===0"><mat-icon>first_page</mat-icon></button>
      <button mat-icon-button (click)="paginate(pageIndex-1, pageSize)" [disabled]="pageIndex===0"><mat-icon>chevron_left</mat-icon></button>
      <button mat-icon-button (click)="paginate(pageIndex+1, pageSize)" [disabled]="pageLength===0"><mat-icon>chevron_right</mat-icon></button>
    </div>
  `,
    styleUrls: ['./paginator.scss'],
    standalone: false
})
export class AppPaginator {

  @Input() public pageIndex: number = 0;
  @Input() public pageLength: number;
  @Input() public pageSize: number;
  @Input() public pageSizeOptions: number[];
  @Output() public page = new EventEmitter<{ pageIndex: number, pageSize: number }>();

  public paginate(pageIndex: number, pageSize: number) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.page.next({ pageIndex: this.pageIndex, pageSize: this.pageSize});
  }
}
